var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade custom",
        attrs: { id: "createAlertModal", role: "dialog" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                (_vm.newRegulatoryAlert || _vm.editRegulatoryAlert) &&
                _vm.status == "Published"
                  ? _c("h4", { staticClass: "modal-title" }, [
                      _vm._v(" Update alert "),
                    ])
                  : _vm.newRegulatoryAlert || _vm.editRegulatoryAlert
                  ? _c("h4", { staticClass: "modal-title" }, [
                      _vm._v(" Create new alert "),
                    ])
                  : _vm.reviewAlertFlag
                  ? _c("h4", { staticClass: "modal-title" }, [
                      _vm._v("Review draft alert"),
                    ])
                  : _vm._e(),
                (_vm.newRegulatoryAlert || _vm.editRegulatoryAlert) &&
                _vm.status == "Published"
                  ? _c("span", [
                      _vm._v(" Step " + _vm._s(_vm.stepCount) + " of 2 "),
                    ])
                  : _c("span", [
                      _vm._v(
                        " Step " +
                          _vm._s(_vm.stepCount) +
                          " of " +
                          _vm._s(_vm.totalStepCount) +
                          " "
                      ),
                    ]),
              ]),
              _c(
                "div",
                { staticClass: "modal-body", attrs: { id: "myWizard" } },
                [
                  _c("div", { staticClass: "container-fluid" }, [
                    _c("div", { staticClass: "tab-content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "tab-pane fade in active",
                          attrs: { id: "createNewAlert1" },
                        },
                        [
                          _vm._m(0),
                          _c(
                            "div",
                            { staticClass: "container-fluid details-field" },
                            [
                              _c("div", { staticClass: "col-md-12" }, [
                                _vm._m(1),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-4 edit-profile-section",
                                  },
                                  [
                                    _c(
                                      "multiselect",
                                      {
                                        staticClass:
                                          "multiselect-single-dropdown",
                                        attrs: {
                                          disabled: _vm.status == "Published",
                                          showLabels: false,
                                          "close-on-select": true,
                                          "allow-empty": false,
                                          searchable: true,
                                          options: _vm.countryList,
                                          label: "country_name",
                                          placeholder: "Select country",
                                        },
                                        on: { input: _vm.onCountrySelect },
                                        model: {
                                          value: _vm.selectedCountry,
                                          callback: function ($$v) {
                                            _vm.selectedCountry = $$v
                                          },
                                          expression: "selectedCountry",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "noResult" },
                                            slot: "noResult",
                                          },
                                          [_vm._v("No matching data")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "col-md-4" }),
                              ]),
                              _c("div", { staticClass: "col-md-12" }, [
                                _vm._m(2),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-10 edit-profile-section",
                                  },
                                  [
                                    _c("vue-editor", {
                                      staticClass: "custom-title",
                                      attrs: {
                                        editorToolbar: _vm.customToolbar,
                                      },
                                      on: {
                                        "text-change": function ($event) {
                                          return _vm.removeStyles()
                                        },
                                      },
                                      model: {
                                        value: _vm.title,
                                        callback: function ($$v) {
                                          _vm.title = $$v
                                        },
                                        expression: "title",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-12" }, [
                                _vm._m(3),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-10 edit-profile-section",
                                  },
                                  [
                                    _c("vue-html5-editor", {
                                      attrs: {
                                        ondrag: "return false",
                                        ondrop: "return false",
                                        autocomplete: "off",
                                        id: "Answer",
                                        height: 145,
                                        "auto-height": false,
                                        content: this.description,
                                      },
                                      on: { change: _vm.updateDescription },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._l(
                                _vm.linkList,
                                function (linkDetail, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "link-loop" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-2 form-title info-link",
                                        },
                                        [
                                          index == 0
                                            ? _c("span", [
                                                _vm._v(
                                                  "Link for more information:"
                                                ),
                                              ])
                                            : _c("label"),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-3 edit-profile-section",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: linkDetail["link"],
                                                expression:
                                                  "linkDetail['link']",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            class: linkDetail["invalid"]
                                              ? "error_msg_display"
                                              : "",
                                            attrs: {
                                              type: "text",
                                              placeholder: "http://",
                                            },
                                            domProps: {
                                              value: linkDetail["link"],
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.validateUrl(
                                                  linkDetail
                                                )
                                              },
                                              focus: function ($event) {
                                                return _vm.enteringUrl(
                                                  linkDetail
                                                )
                                              },
                                              paste: function ($event) {
                                                return _vm.onPaste(
                                                  $event,
                                                  index
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  linkDetail,
                                                  "link",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm.getstyle(linkDetail) || _vm.pasteError
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-3 error_msg_mob",
                                            },
                                            [_vm._v(" Please enter valid url ")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-5 edit-profile-section",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: linkDetail["label"],
                                                expression:
                                                  "linkDetail['label']",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Link label",
                                              disabled:
                                                _vm.isLabelDisabled(linkDetail),
                                            },
                                            domProps: {
                                              value: linkDetail["label"],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  linkDetail,
                                                  "label",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-2 edit-profile-section",
                                        },
                                        [
                                          index < _vm.linkList.length - 1
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-modal-footer remove-link",
                                                  staticStyle: {
                                                    width: "115px",
                                                  },
                                                  attrs: {
                                                    id: "removeLink",
                                                    "data-toggle": "tab",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeLinkClicked(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Remove link ")]
                                              )
                                            : _vm._e(),
                                          index == _vm.linkList.length - 1
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-modal-footer add-link",
                                                  staticStyle: {
                                                    width: "115px",
                                                  },
                                                  attrs: {
                                                    id: "addLink",
                                                    "data-toggle": "tab",
                                                  },
                                                  on: {
                                                    click: _vm.addLinkClicked,
                                                  },
                                                },
                                                [_vm._v(" Add link ")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c("div", { staticClass: "col-md-12" }, [
                                        _vm.getstyle(linkDetail)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-3 error_msg_desk",
                                              },
                                              [
                                                _vm._v(
                                                  " Please enter valid url "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-2 form-title" },
                                  [_vm._v("Effective Date:")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-3 edit-profile-section",
                                  },
                                  [
                                    _c("date-picker", {
                                      attrs: {
                                        editable: false,
                                        placeholder: "DD-MM-YYYY",
                                        format: "DD-MM-YYYY",
                                      },
                                      on: { change: _vm.formatDescription },
                                      model: {
                                        value: _vm.effectiveDate,
                                        callback: function ($$v) {
                                          _vm.effectiveDate = $$v
                                        },
                                        expression: "effectiveDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "col-md-4" }),
                              ]),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "tab-pane fade in",
                          attrs: { id: "createNewAlert2" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "container-fluid inherit-height" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12",
                                  staticStyle: { "padding-left": "0" },
                                },
                                [
                                  _vm._v(
                                    " Review the draft below (this is what RAMS users will see). "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "inherit-height alert-new-height",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-md-5 inherit-height",
                                      staticStyle: { "padding-right": "0px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("Alert preview")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "alert-popup" },
                                        [
                                          _c("div", {
                                            staticStyle: {
                                              "padding-top": "35px",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "alert-preview" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "600",
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " 1 New regulatory update "
                                                  ),
                                                ]
                                              ),
                                              _c("div", {
                                                staticClass: "alert-divider",
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "flex",
                                                  staticStyle: {
                                                    padding: "5px 0",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "notify-icon",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "flag-icon flag-icon-squared",
                                                        class: _vm.countryFlag(
                                                          _vm.selectedCountry
                                                            .country_code
                                                        ),
                                                      }),
                                                    ]
                                                  ),
                                                  _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "alert-title update-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .selectedCountry
                                                                .country_name
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "ellipsis",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            ref: "alertDescDiv",
                                                          },
                                                          [
                                                            _c("p", {
                                                              staticClass:
                                                                "alert-description",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.alertDescription
                                                                  ),
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm.learnMoreShowHide
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "alert-link",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " See details... "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]),
                                                ]
                                              ),
                                              _c("div", {
                                                staticClass: "alert-divider",
                                              }),
                                              _vm._m(4),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-7 inherit-height" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "alert-detail",
                                          staticStyle: {
                                            "text-align": "center",
                                            "padding-bottom": "35px",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v(" Alert detail ")]
                                      ),
                                      _c("div", [
                                        _c("div", {
                                          staticClass: "alert-divider",
                                        }),
                                        _c("div", { staticClass: "flex p-0" }, [
                                          _c(
                                            "div",
                                            { staticClass: "notify-icon" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "flag-icon flag-icon-squared",
                                                class: _vm.countryFlag(
                                                  _vm.selectedCountry
                                                    .country_code
                                                ),
                                              }),
                                            ]
                                          ),
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert-title update-title",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.selectedCountry
                                                        .country_name
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "alert-description",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.alertDescription
                                                ),
                                              },
                                            }),
                                            _c(
                                              "li",
                                              {
                                                staticStyle: {
                                                  display: "grid",
                                                },
                                              },
                                              _vm._l(
                                                _vm.linkList,
                                                function (linkDetail, index) {
                                                  return _c(
                                                    "a",
                                                    {
                                                      key: index,
                                                      staticClass: "alert-link",
                                                      attrs: {
                                                        href: linkDetail[
                                                          "link"
                                                        ],
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          linkDetail["label"]
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]),
                                        ]),
                                        _c("div", {
                                          staticClass: "alert-divider",
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "tab-pane fade in",
                          attrs: { id: "createNewAlert3" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12",
                              staticStyle: { "padding-left": "0" },
                            },
                            [
                              _vm.status != "Published"
                                ? _c("span", [
                                    _vm._v(
                                      "When would you like to publish the alert?"
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "Please click Finish to update the published alert."
                                    ),
                                  ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "container-fluid publish-alert" },
                            [
                              _vm.status != "Published"
                                ? _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-4 col-md-offset-4 col-sm-offset-2 col-sm-8",
                                      },
                                      [
                                        _c("div", { staticClass: "radio" }, [
                                          _c(
                                            "label",
                                            {
                                              class: {
                                                activeRadio:
                                                  _vm.publishValue == 0,
                                              },
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.publishValue,
                                                    expression: "publishValue",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  name: "publishRadio",
                                                  value: "0",
                                                  disabled:
                                                    _vm.status == "Published",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.publishValue,
                                                    "0"
                                                  ),
                                                },
                                                on: {
                                                  click: _vm.chngImdStatusFlg,
                                                  change: function ($event) {
                                                    _vm.publishValue = "0"
                                                  },
                                                },
                                              }),
                                              _c("span", [
                                                _vm._v("Immediately"),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm.status != "Published"
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-modal-footer back",
                          attrs: {
                            id: "footerBack",
                            "data-toggle": "tab",
                            disabled: _vm.stepCount == 1,
                          },
                          on: { click: _vm.backClicked },
                        },
                        [
                          _c("i", { staticClass: "fa fa-arrow-left" }),
                          _vm._v(" Back "),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-modal-footer cancel",
                          attrs: {
                            id: "footerCancel",
                            type: "button",
                            "data-toggle": "tab",
                          },
                          on: { click: _vm.cancelClicked },
                        },
                        [
                          _c("i", { staticClass: "fa fa-times-circle" }),
                          _vm._v(" Cancel "),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-modal-footer back",
                          attrs: {
                            id: "footerSave",
                            "data-toggle": "tab",
                            disabled: _vm.disbleSaveForLaterButton,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveClicked(true)
                            },
                          },
                        },
                        [_vm._v(" Save for later ")]
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-6" }, [
                      _vm.stepCount != 3
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-modal-footer",
                              attrs: {
                                id: "footerNext",
                                "data-toggle": "tab",
                                disabled: _vm.disableStatus,
                              },
                              on: { click: _vm.nextClicked },
                            },
                            [
                              _vm._v(" Next "),
                              _c("i", { staticClass: "fa fa-arrow-right" }),
                            ]
                          )
                        : _vm._e(),
                      _vm.stepCount == 3 && _vm.imd_status_flag
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-modal-footer",
                              attrs: {
                                id: "footerInProgress",
                                "data-toggle": "tab",
                                disabled: _vm.imd_status_flag,
                              },
                            },
                            [_vm._v(" In-progress ")]
                          )
                        : _vm._e(),
                      _vm.stepCount == 3 && !_vm.imd_status_flag
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-modal-footer",
                              attrs: {
                                id: "footerFinish",
                                "data-toggle": "tab",
                                disabled:
                                  _vm.loaderStatus ||
                                  (!_vm.publishDate && _vm.publishValue === 1),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.saveClicked(false)
                                },
                              },
                            },
                            [_vm._v(" Finish ")]
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm.status == "Published"
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c("div", { staticClass: "col-md-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-modal-footer back",
                          attrs: {
                            id: "footerBack",
                            "data-toggle": "tab",
                            disabled: _vm.stepCount == 1,
                          },
                          on: { click: _vm.backClicked },
                        },
                        [
                          _c("i", { staticClass: "fa fa-arrow-left" }),
                          _vm._v(" Back "),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-modal-footer cancel",
                          attrs: {
                            id: "footerCancel",
                            type: "button",
                            "data-toggle": "tab",
                          },
                          on: { click: _vm.cancelClicked },
                        },
                        [
                          _c("i", { staticClass: "fa fa-times-circle" }),
                          _vm._v(" Cancel "),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-4" }, [
                      _vm.stepCount != 2
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-modal-footer",
                              attrs: {
                                id: "footerNext",
                                "data-toggle": "tab",
                                disabled: _vm.disableStatus,
                              },
                              on: { click: _vm.nextClicked },
                            },
                            [
                              _vm._v(" Next "),
                              _c("i", { staticClass: "fa fa-arrow-right" }),
                            ]
                          )
                        : _vm._e(),
                      _vm.stepCount == 2 && _vm.status == "Published"
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-modal-footer",
                              attrs: {
                                id: "footerFinish",
                                "data-toggle": "tab",
                                disabled: _vm.loaderStatus,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.updateClicked()
                                },
                              },
                            },
                            [_vm._v(" Update ")]
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-12", staticStyle: { "padding-left": "0" } },
      [
        _vm._v(" Enter the details below ( "),
        _c("span", { staticStyle: { color: "red" } }, [
          _vm._v(" * = Required field "),
        ]),
        _vm._v("): "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-2 form-title" }, [
      _vm._v(" Country: "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-2 form-title" }, [
      _vm._v(" Title: "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-2 form-title" }, [
      _vm._v(" Description: "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "text-align": "center" } }, [
      _c("a", { staticClass: "alert-link" }, [_vm._v("View all")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }